'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchVenue = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _commaSeparate = require('helpers/commaSeparate');

var _distance = require('helpers/distance');

var _measurement = require('constants/measurement');

var _Venue2 = require('models/Venue');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchVenue = exports.SearchVenue = function (_Venue) {
  (0, _inherits3.default)(SearchVenue, _Venue);

  function SearchVenue() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, SearchVenue);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchVenue.__proto__ || (0, _getPrototypeOf2.default)(SearchVenue)).call(this, data));

    var distance = data.distance && config.distanceUnit === _measurement.DISTANCE_UNITS.mi ? (0, _distance.distanceInMiles)(data.distance) : data.distance;

    (0, _assign2.default)(_this, {
      activities: (0, _commaSeparate.commaSeparate)(data.activities, 2),
      distance: distance && distance.toFixed(1),
      distanceUnit: config.distanceUnit,
      locationNameHighlighted: data.neighborhood_highlighted || _this.locationName,
      nameHighlighted: data.name_highlighted || _this.name,
      searchId: data.search_id
    });
    return _this;
  }

  return SearchVenue;
}(_Venue2.Venue);